import _ from 'lodash';
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "../utils";
import axios from "axios";

const initialState = {
   TotalSpindleLoading: false,
   TotalAvailable: 0,
};

export default function useGetTotalSpindles(
   MachineInfo,
   MachinePlan,
   days = 0,
   side = ""
) {
   const cancelToken = axios.CancelToken;
   const source = cancelToken.source();
   const [list, setList] = useState(initialState);
   const Side = side;
   const { MachineSelect, MachineNumber } = MachineInfo;
   const { MachineId } = MachinePlan;

   useEffect(() => {
      // Flag set in cleanup so a superseded run can't clobber the latest side's
      // value with a stale/zero result after its requests were canceled.
      let ignore = false;
      let obj = { ...initialState };
      if (_.isNil(MachineSelect)) {
         setList(obj);
         return;
      }
      try {
         async function UsedSpindleAPI() {
            let UsedSpindles = 0;
            await api
               .postS(
                  `Production/GetUsedSpindles`,
                  { ...MachinePlan, ItemClass: "", ItemNumber: "", Days: days, MachineNum: MachineNumber?.value || 0, Side: Side },
                  source.token
               )
               .then((r) => {
                  // Canceled/superseded requests resolve without a body — ignore them.
                  if (axios.isCancel(r) || !r?.data) return;
                  if (r.data.success) {
                     UsedSpindles = r.data.usedSpindles;
                  } else {
                     toast.error("GetUsedSpindles query returned an error");
                  }
               })
               .catch((e) => { if (!axios.isCancel(e)) api.catchHandler(e); });
            return UsedSpindles;
         }

         async function TotalSpindle(id) {
            let SpindleCount = 0;
            await api
               .fetchS(
                  `Production/GetMachineSetupTotalSpindles/${id}`,
                  {},
                  source.token
               )
               .then((r) => {
                  if (axios.isCancel(r) || !r?.data) return;
                  if (r.data.success) {
                     SpindleCount = r.data.totalSpindles;
                  } else {
                     toast.error("GetMachineSetupTotalSpindles query returned an error");
                  }
               })
               .catch((e) => { if (!axios.isCancel(e)) api.catchHandler(e); });
            return SpindleCount;
         }

         async function GetActiveMachine() {
            let SpindleCount = 0;
            await api
               .postS(`Production/GetActiveMachines`, {
                  MachineId: MachineSelect.value,
                  MachineNum: MachineNumber.value,
                  Side: Side,
               })
               .then((r) => {
                  if (axios.isCancel(r) || !r?.data) return;
                  if (r.data.success) {
                     SpindleCount = r.data.spindleCount;
                  } else {
                     toast.error("GetActiveMachines query returned an error");
                  }
               })
               .catch((e) => { if (!axios.isCancel(e)) api.catchHandler(e); });
            return SpindleCount;
         }

         async function CallUsedTotalSpindle(id) {
            return await TotalSpindle(id);
         }

         async function CallUsedSpindles() {
            return await UsedSpindleAPI(true);
         }

         async function CallActiveMachine() {
            return await GetActiveMachine();
         }

         async function oneItemSelected() {
            setList({ ...list, TotalSpindleLoading: true });
            if (!MachineId || typeof MachineId !== "number") {
               obj.TotalSpindleLoading = false;
               if (!ignore) setList(obj);
               return;
            }
            SpindleCount = await CallUsedTotalSpindle(MachineId);
            UsedSpindles = await CallUsedSpindles();
            let Available = SpindleCount - UsedSpindles;
            obj.TotalAvailable = Available > 0 ? Available : 0;
            obj.TotalSpindleLoading = false;
            if (!ignore) setList({ ...obj });
         }

         async function bothItemsSelected() {
            setList({ ...list, TotalSpindleLoading: true });
            SpindleCount = await CallActiveMachine();
            UsedSpindles = await CallUsedSpindles();
            let Available = SpindleCount - UsedSpindles;
            obj.TotalAvailable = Available > 0 ? Available : 0;
            obj.TotalSpindleLoading = false;
            if (!ignore) setList({ ...obj });
         }

         if (_.isNil(MachinePlan)) {
            setList(obj);
            return;
         }

         let SpindleCount = 0;
         let UsedSpindles = 0;

         if (!_.isNil(MachineSelect) && !_.isNil(MachineNumber)) {
            bothItemsSelected();
         } else if (!_.isNil(MachineSelect) && _.isNil(MachineNumber)) {
            oneItemSelected();
         }
      } catch (error) {
         obj.TotalSpindleLoading = false;
         setList({ ...obj });
         toast.error(error);
      }

      return () => {
         ignore = true;
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [MachineSelect, MachineNumber, side, MachinePlan]);

   return list;
}
